// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-spinner{text-align:center}@-webkit-keyframes v-scaleStretchDelay{0%,to{transform:scaleY(1)}50%{transform:scaleY(.4)}}@keyframes v-scaleStretchDelay{0%,to{transform:scaleY(1)}50%{transform:scaleY(.4)}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
